import React from "react";

import { AvatarSize, avatarSizes } from "./sizes";
import { PaziaAvatarPlaceholder } from "./PaziaAvatarPlaceholder";

interface UserAvatarProps {
  avatar?: string;
  firstName?: string;
  surname?: string;
  alt?: string;
  size?: AvatarSize;
}

export const UserAvatar = ({
  avatar,
  firstName = "N",
  surname = "U",
  alt,
  size = "small",
}: UserAvatarProps): JSX.Element => {
  const sizeClass = avatarSizes[size];
  if (avatar) return <img className={`${sizeClass} object-cover rounded-full`} src={avatar} alt={alt} />;
  return <PaziaAvatarPlaceholder size={size} firstName={firstName} surname={surname} />;
};
